// maskPhone.js
export function maskPhone(phone, visible = 3) {
    if (!phone) return "";

    // Keep original to detect '+' and return formatted result
    const original = String(phone);

    // Extract digits only (for masking logic)
    const digits = original.replace(/\D/g, "");
    if (digits.length <= visible) return original;

    // Detect leading +countrycode (1-3 digits) if present
    const plusMatch = original.match(/^\+(\d{1,3})/);
    const countryCode = plusMatch ? "+" + plusMatch[1] : "";

    // Remove country-code digits from digits string (if we kept it)
    const ccDigits = plusMatch ? plusMatch[1] : "";
    const rest = ccDigits ? digits.slice(ccDigits.length) : digits;

    const last = rest.slice(-visible);
    const maskedMiddle = "*".repeat(Math.max(0, rest.length - visible));

    return countryCode + maskedMiddle + last;
}
